import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import SearchAndResultsContainer from './SearchAndResultsContainer';
import CrmAccountActions from 'actions/crm-opp-ui/CrmAccountActions';
import CrmAccountStore from 'stores/crm-opp-ui/CrmAccountStore';

@connectToStores
export default class AccountSearch extends React.Component {
  constructor(props) {
    super(props);
    this.entityClick = this.entityClick.bind(this);
  }

  static getStores() {
    return [CrmAccountStore];
  }

  static getPropsFromStores() {
    const store = CrmAccountStore.getState();
    return {
      accounts: store.searchResults,
      searchTerm: store.searchTerm,
      isSearching: store.isSearching,
    };
  }

  entityClick(entity) {
    this.props.selectEntity(entity);
    CrmAccountActions.setSearchTerm(entity.name);
  }

  render() {
    const {
      autoFocus,
      accounts,
      searchTerm,
      isSearching,
      entityLoaded,
      placeholder = 'Type contact or account name to search',
      className,
      searchDisabled = false,
    } = this.props;

    const filteredAccounts = this.props.filterResults
      ? this.props.filterResults(accounts)
      : accounts;

    return (
      <SearchAndResultsContainer
        autoFocus={autoFocus}
        placeholder={placeholder}
        executeSearch={CrmAccountActions.searchAccounts}
        tabIndex={1}
        searchResults={filteredAccounts}
        searchTerm={searchTerm}
        selectEntity={this.entityClick}
        entityLoaded={entityLoaded}
        isSearching={isSearching}
        className={className}
        searchDisabled={searchDisabled}
      />
    );
  }
}
